import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Selector of the checkbox that keeps the record under client control. The guard disables it
   * while a tracked field differs from its saved value, switching it on if it was off, and enables
   * it again once every field returns to its saved value, switching it back off if the guard
   * switched it on.
   *
   * @type {String}
   */
  control: {
    type: String,
    required: true,
  },
  /**
   * Selector of the element to reveal while a tracked field differs from its saved value, and to
   * hide otherwise. The guard toggles the element's `hidden` attribute. The page supplies and
   * places the element.
   *
   * @type {String}
   */
  warning: {
    type: String,
    default: "",
  },
  /**
   * Comma-separated selectors of fields to track in addition to the ones a canonical "Edit Anyway"
   * link (`[data-behaviour~="enable-input"][data-canonical-unlock]`, through its `data-target`)
   * unlocks. A field matched after
   * mount is compared against the value it was rendered with.
   *
   * @type {String}
   */
  fields: {
    type: String,
    default: "",
  },
  /**
   * Comma-separated selectors of list items whose set is tracked, e.g. the items of an assignment
   * list. Adding or removing an item counts as a change.
   *
   * @type {String}
   */
  watch: {
    type: String,
    default: "",
  },
  /**
   * Leaves the fields an "Edit Anyway" link unlocks untracked, so the guard tracks only the
   * `fields` and `watch` selectors. Lets a second guard on the same form drive a different
   * checkbox from its own fields.
   *
   * @type {Boolean|String}
   */
  ignoreUnlocked: booleanAttribute(),
  /**
   * Selector of the form to observe. Defaults to the closest form ancestor. Without a form the
   * guard does nothing.
   *
   * @type {String}
   */
  form: {
    type: String,
    default: "",
  },
});
